// @ts-check

export const referenceActionIcon = Object.freeze({
  edit: '$pencil',
  delete: '$trash-can-outline',
  invalidate: '$close-circle-outline',
  mark_as_paid: '$check-circle-outline'
})

export const referenceActionVariant = Object.freeze({
  edit: 'primary',
  delete: 'danger',
  invalidate: 'danger',
  mark_as_paid: 'success'
})

export const referenceStatusIcon = Object.freeze({
  draft: '$pencil',
  paid: '$check',
  error: '$close',
  invalidated: '$check'
})

export const referenceStatusVariant = Object.freeze({
  paid: 'success',
  error: 'danger',
  invalidated: 'success'
})
